import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createMockProduct } from "../mockCore";
import * as demoBrandFns from "./demoBrand";

const resaleProducts = [
    {
        product: createMockProduct({
            id: 240,
            productName: "Nano Puff Women Insulated Jacket",
            imageSrc: "/mocks/patagonia-jacket-red.jpeg",
            purchasePrice: 799,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 5,
            productName: "Altvia Alpine Women Outdoor-Trousers",
            imageSrc: "/mocks/patagonia-pants-blue.jpeg",
            purchasePrice: 499,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 6,
            productName: "Better Sweater Women Fleece Jacket",
            imageSrc: "/mocks/patagonia-sweater-red.jpeg",
            purchasePrice: 300,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 7,
            productName: "Mock Neck Sweater",
            imageSrc: "/mocks/Sweater bright green.png",
            purchasePrice: 899,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 8,
            productName: "Sequin Mini Skirt",
            imageSrc: "/mocks/Green skirt.png",
            purchasePrice: 1002,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 9,
            productName: "Elizabeth Vest",
            imageSrc: "/mocks/Metallic Corset.png",
            purchasePrice: 99,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 10,
            productName: "Signe Dress",
            imageSrc: "/mocks/odd molly - white dress.jpeg",
            purchasePrice: 199,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 11,
            productName: "Colette Pants",
            imageSrc: "/mocks/odd molly - white jeans.jpeg",
            purchasePrice: 150,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 12,
            productName: "Elizabeth Vest",
            imageSrc: "/mocks/odd molly - vest black.jpeg",
            purchasePrice: 200,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 13,
            productName: "superlight Vest",
            imageSrc: "/mocks/Norrona - Vest indigo.png",
            purchasePrice: 200,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 14,
            productName: "slim Pants",
            imageSrc: "/mocks/Norrona - slim Pants tourmaline.png",
            purchasePrice: 1599,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 15,
            productName: "warm3 Jacket",
            imageSrc: "/mocks/Norrona - warm3 Jacket White.png",
            purchasePrice: 1900,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 16,
            productName: "Pattern dress",
            imageSrc: "/mocks/Pattern dress - Pink.png",
            purchasePrice: 740,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 17,
            productName: "Socks, 2 pack",
            imageSrc: "/mocks/Socks - Pink.png",
            purchasePrice: 89,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 18,
            productName: "Floral print jacket",
            imageSrc: "/mocks/Jacket - Beige.png",
            purchasePrice: 1200,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 19,
            productName: "Marline Organic Cotton Sweater",
            imageSrc: "/mocks/lexington sweater - Light Blue Melange.png",
            purchasePrice: 1300,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 20,
            productName: "Cleo Linen Pants",
            imageSrc: "/mocks/lexington pants - Dark Blue.png",
            purchasePrice: 170,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 21,
            productName: "Original Towel x4",
            imageSrc: "/mocks/lexington towel - Gray Olive.png",
            purchasePrice: 160,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 22,
            productName: "Benz Jeans",
            imageSrc: "/mocks/Eytys Jeans - Light Stone.jpeg",
            purchasePrice: 220,
            resaleActive: true,
        }),
    },
    {
        product: createMockProduct({
            id: 23,
            productName: "Doja Sneakers",
            imageSrc: "/mocks/Eytys Sneakers - White.jpeg",
            purchasePrice: 1050,
            resaleActive: true,
        }),
    },
];

const demoBrandProducts = demoBrandFns.getProducts()?.products;

const orders = [
    {
        products: demoBrandProducts,
        resaleActive: false,
    },
    {
        products: resaleProducts.map((rp) => rp.product),
        resaleActive: true,
    },
];

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        pickupDateSelectionAllowed: true,
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        orders: orders,
    };
}
